import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface FlashMessage {
  id: string
  type: 'success' | 'error' | 'info'
  message: string
  timestamp: number
}

interface FlashMessageState {
  messages: FlashMessage[]
}

const initialState: FlashMessageState = {
  messages: []
}

const flashMessageSlice = createSlice({
  name: 'flashMessage',
  initialState,
  reducers: {
    addFlashMessage: (
      state,
      action: PayloadAction<{ type: 'success' | 'error' | 'info'; message: string }>
    ) => {
      const newMessage: FlashMessage = {
        id: `${Date.now()}-${Math.random()}`,
        timestamp: Date.now(),
        ...action.payload
      }
      state.messages.push(newMessage)
    },
    removeFlashMessage: (state, action: PayloadAction<string>) => {
      state.messages = state.messages.filter(msg => msg.id !== action.payload)
    },
    clearAllFlashMessages: state => {
      state.messages = []
    }
  }
})

export const { addFlashMessage, removeFlashMessage, clearAllFlashMessages } =
  flashMessageSlice.actions
export default flashMessageSlice.reducer
export type { FlashMessage }
